import JustInPreview from './just-in-preview.component';

export default JustInPreview;
